module.exports = __webpack_public_path__ + "img/dashboard-active.d763213b.svg";